import {
  Stack,
  SvgIcon,
  Typography,
  Button,
  Box,
  FormHelperText,
} from "@mui/material";
import { useContext } from "react";
import { SocialCampaignContext } from "../Context";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { isTruthy } from "helpers/methods";
import { SocialCampaign } from "types/Campaign";
import strings from "global/constants/StringConstants";
import Facebook from "./FacebookCard";
import Instagram from "./InstagramCard";

interface CustomProps {
  setIsDesignPostModalOpen: Function;
  socialCampaign: SocialCampaign;
  formFields: any;
  setFormFields: Function;
  carousalIndex: number;
  setCarousalIndex: Function;
  postImage: string[];
}

const DesignSection = (props: CustomProps) => {
  const { managingStep, submitCampaign } = useContext(SocialCampaignContext);

  const stepCompletion = () => {
    return (
      isTruthy(submitCampaign.socialCampaign.message) ||
      isTruthy(submitCampaign.socialCampaign.link)
    );
  };

  const getSelectedAppCard = () => {
    switch (submitCampaign.socialAppName) {
      case strings.FACEBOOK: {
        return (
          <Facebook
            formFields={props.formFields}
            imageArray={props.postImage}
            carousalIndex={props.carousalIndex}
            setCarousalIndex={props.setCarousalIndex}
          />
        );
      }
      case strings.INSTAGRAM: {
        return (
          <Instagram
            formFields={props.formFields}
            imageArray={props.postImage}
            carousalIndex={props.carousalIndex}
            setCarousalIndex={props.setCarousalIndex}
          />
        );
      }
    }
  };

  const getPreview = () => {
    return (
      <Stack
        width="100%"
        sx={{ backgroundColor: "#DCE2EB", borderRadius: "8px" }}
        mt={2}
        alignItems="center"
        justifyContent="center"
      >
        <Box p={5}>{getSelectedAppCard()}</Box>
      </Stack>
    );
  };

  const getNonExpandedView = () => {
    const onAnotherStep =
      managingStep !== "" && managingStep !== "design-section";
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ opacity: onAnotherStep ? 0.5 : 1 }}
        spacing={4}
      >
        <Stack direction="row" spacing={4}>
          <SvgIcon>
            <CheckCircleIcon
              htmlColor={stepCompletion() ? "#7551D0" : "#C1C1C1"}
            />
          </SvgIcon>
        </Stack>
        <Stack width="100%">
          <Stack direction="row" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="h4">Design</Typography>
              <Typography variant="body1">Create your post content</Typography>
            </Stack>
            <Stack>
              <Button
                size="small"
                variant="outlined"
                onClick={() => props.setIsDesignPostModalOpen(true)}
                disabled={onAnotherStep}
              >
                {`${stepCompletion() ? "Edit Design" : "Start Designing"}`}
              </Button>
            </Stack>
          </Stack>
          {(submitCampaign.socialCampaign.message ||
            submitCampaign.socialCampaign.link.length > 0) &&
            getPreview()}
        </Stack>
      </Stack>
    );
  };

  const getPage = () => {
    return getNonExpandedView();
  };

  return <Box px={3}>{getPage()}</Box>;
};

export default DesignSection;
